var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14109_43216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9615 8.67876C14.1024 7.44164 13.8549 6.19132 13.2534 5.10114C12.6519 4.01095 11.7261 3.13491 10.6044 2.59445C9.48265 2.054 8.22058 1.8759 6.99311 2.08485C5.76565 2.2938 4.63359 2.87945 3.75388 3.76061C2.87417 4.64176 2.29038 5.77478 2.08345 7.00259C1.87651 8.23039 2.05668 9.49217 2.59898 10.613C3.14128 11.7338 4.01884 12.6582 5.11001 13.2579C6.20118 13.8576 7.4519 14.103 8.6888 13.9601",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.66675V8.00008L9.33333 9.33341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 11.3333V14.6666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3333V14.6666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14109_43216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/Resume.d1169077553daa42baeec364df817d6f.svg";
export { ForwardRef as ReactComponent };